import React, { Component } from 'react';
import { Add1, Add2, Add3, Add4, Add5, Add6, Add7, Add8, Add9 } from '../components';
import { Col } from 'react-bootstrap';

const ads = [ Add1, Add2, Add3, Add4, Add5, Add6, Add7, Add8, Add9 ];

class Randomizer {
  constructor(arr) {
    this.arr = arr;
    this.used = [];
  }

  rand() {
    const numb = Math.floor(Math.random() * this.arr.length);
    if (this.used.indexOf(numb) !== -1) {
      return this.rand();
    }
    return numb;
  }

  pickOne() {
    if (this.arr.length <= this.used.length) {
      return null;
    }
    return this.arr[this.rand()];
  }

  pick(amount=1) {
    if (this.arr.length <= this.used.length) {
      return null;
    }

    const result = [];
    for(; amount > 0; amount--){
      result.push(this.pickOne());
    }
    return result;
  }
}

class NoVacancy extends Component {

  randomAds(amount) {
    const adPicker = new Randomizer(ads);
    return adPicker.pick(amount);
  }

  render(){
    return (
      <div>
        <Col lg={ 12 }>
          <h4>Lejligheden er desværre udlejet</h4>
        </Col>
        {this.randomAds(3).map( (Comp, idx) => <Comp key={ idx } /> )}
      </div>

    )
  }
}

export default NoVacancy;
